import { API_BASE } from '../net/base';
// @ts-nocheck
/** MI DOMINO - economy/tienda. */
import { recordSale } from '../admin/portal';
import { openDash, renderDash } from '../ui/dashboard';
import { BUNDLES, COLLECTIBLES, FLAG_LIST, PACK_PRICE, RARITY, SELL_VALUES, STORE, idesc, iname } from '../data/catalog';
import { MARKET_FEE, TP_TABS, WOOD_SW } from '../data/config';
import { applyBling, syncFeltSelect, syncSkinSelect, syncWoodSelect, updateCoinBal } from './wallet';
import { L, fireworks, showModal } from '../game/engine';
import { celebration, clack, explosion, siren } from '../game/sounds';
import { PIP_MAP } from '../game/tile';
import { applyProfile, cloudSync, saveAccount, teamCode, updateRankBadge, upsertSelfUser } from '../identity/profile';
import { ACCOUNT, PROFILE, STATS, TEAM, WALLET, setDashTab, setTpTab, tpTab } from '../state';
import { banner } from '../ui/banner';
import { log } from '../ui/feed';
import { LANG, t } from '../ui/i18n';

export function isPro() { return !!WALLET.pro; }

export function openStore() {
  let html = `<p>${L('Tu balance', 'Your balance')}: <b style="color:var(--gold)">${WALLET.coins} 🪙 PhilCoins</b></p>
    <p style="opacity:.7;font-size:12px">${L('Gana 🪙 jugando: +25 por mano ganada · +150 por partida ganada.', 'Earn 🪙 by playing: +25 per hand won · +150 per match won.')}</p>`;
  for (const it of STORE) {
    const owned = WALLET.owned.includes(it.id);
    const active = WALLET.active.includes(it.id);
    html += `<div style="display:flex;align-items:center;gap:8px;margin:7px 0;text-align:left">
      <span style="font-size:20px">${it.icon}</span>
      <span style="flex:1;min-width:0"><b>${iname(it)}</b>${active ? ` <small style="color:var(--gold)">● ${L('activo', 'active')}</small>` : ''}<br><small style="opacity:.7">${idesc(it)}</small></span>
      <button class="btn${owned ? '' : ' gold'}" style="margin:0;width:auto;padding:7px 10px;font-size:12px;white-space:nowrap" data-act="${it.id}">
        ${owned ? (active ? t('unequip') : t('equip')) : it.price + ' 🪙'}</button></div>`;
  }
  showModal(L('✨ TIENDA DE LA MESA', '✨ TABLE STORE'), html, t('close'), () => {});
  for (const b of document.querySelectorAll('[data-act]')) {
    b.onclick = () => {
      const it = STORE.find(s => s.id === b.dataset.act);
      if (!it) return;
      if (!WALLET.owned.includes(it.id)) {
        if (WALLET.coins < it.price) {
          log(L(`No te alcanzan los 🪙 para ${iname(it)}. ¡Gana partidas!`, `Not enough 🪙 for ${iname(it)}. Win some matches!`), true);
          return;
        }
        WALLET.coins -= it.price;
        WALLET.owned.push(it.id);
        if (it.kind === 'skin') WALLET.active = WALLET.active.filter(id => !id.startsWith('skin-'));
        WALLET.active.push(it.id);
        log(L(`Compraste ${iname(it)} ✨`, `You bought ${iname(it)} ✨`), true);
        clack();
      } else if (WALLET.active.includes(it.id)) {
        WALLET.active = WALLET.active.filter(x => x !== it.id);
      } else {
        if (it.kind === 'skin') WALLET.active = WALLET.active.filter(id => !id.startsWith('skin-'));
        WALLET.active.push(it.id);
      }
      saveWallet();
      openStore();
    };
  }
}

export function colTileHTML(c, big) {
  const w = big ? 96 : 58, h = big ? 180 : 108, p = big ? 12 : 7, pad = big ? 10 : 6;
  const half = v => `<div style="flex:1;display:grid;grid-template-columns:repeat(3,1fr);grid-template-rows:repeat(3,1fr);padding:${pad}px">` +
    [0,1,2,3,4,5,6,7,8].map(i => PIP_MAP[v].includes(i)
      ? `<div style="width:${p}px;height:${p}px;border-radius:50%;background:${c.pip};align-self:center;justify-self:center;box-shadow:inset 0 1px 1px rgba(0,0,0,.5)"></div>`
      : '<div></div>').join('') + '</div>';
  const rc = RARITY[c.r][2];
  return `<div style="width:${w}px;height:${h}px;border-radius:${big ? 12 : 8}px;background:${c.face};border:${big ? 3 : 2}px solid ${rc};display:flex;flex-direction:column;position:relative;margin:0 auto;box-shadow:0 ${big ? 8 : 4}px ${big ? 18 : 8}px rgba(0,0,0,.55), 0 0 ${big ? 22 : 8}px ${rc}55">
    ${half(c.a)}<div style="height:2px;background:rgba(0,0,0,.4);margin:0 ${pad}px"></div>${half(c.b)}
    <span style="position:absolute;bottom:${big ? 4 : 2}px;right:${big ? 6 : 4}px;font-size:${big ? 20 : 13}px">${c.icon}</span>
  </div>`;
}

export function pullCollectible(minR) {
  const roll = Math.random() * 100;
  let r = 1;
  if (roll < RARITY[4][3]) r = 4;
  else if (roll < RARITY[4][3] + RARITY[3][3]) r = 3;
  else if (roll < RARITY[4][3] + RARITY[3][3] + RARITY[2][3]) r = 2;
  if (minR && r < minR) r = minR;
  const pool = COLLECTIBLES.filter(c => c.r === r);
  const c = pool[Math.floor(Math.random() * pool.length)];
  WALLET.mint[c.id] = (WALLET.mint[c.id] || 0) + 1;
  const serial = WALLET.mint[c.id];
  WALLET.collect.push({ id: c.id, serial, ts: Date.now() });
  saveWallet();
  return { c, serial, r };
}

export function revealCollectible(p, why) {
  const { c, serial, r } = p;
  if (r === 4) { siren(); fireworks(); banner(L('¡LEGENDARIA! 👑', 'LEGENDARY! 👑')); }
  else if (r === 3) { explosion(); banner(L('¡ÉPICA! 🔮', 'EPIC! 🔮')); }
  else clack();
  const rName = LANG === 'en' ? RARITY[r][1] : RARITY[r][0];
  showModal(t('colGot'),
    `<div style="margin:10px 0">${colTileHTML(c, true)}</div>
     <p style="font-size:18px"><b>${iname(c)}</b></p>
     <p style="color:${RARITY[r][2]};font-weight:800;letter-spacing:1px">${rName.toUpperCase()} · #${String(serial).padStart(4, '0')}</p>
     <p style="font-size:12px;opacity:.75">${why}</p>
     <p style="font-size:11px;opacity:.6">${t('colNote')}</p>`,
    t('close'), () => { try { renderDash(); } catch (e) {} });
  log(`${why}: ${iname(c)} (${rName} #${serial}) ✨`, true);
}

export function buyPack() {
  if (WALLET.coins < PACK_PRICE) {
    log(L('No te alcanzan los 🪙 para el sobre. ¡Gana partidas!', 'Not enough 🪙 for the pack. Win some matches!'), true);
    return;
  }
  WALLET.coins -= PACK_PRICE;
  revealCollectible(pullCollectible(0), LANG === 'en' ? 'Pack opened' : 'Sobre abierto');
}

/** Bundle display name: index 1 is ES, index 6 (when present) is EN. */
function bundleName(b) { return (LANG === 'en' && b[6]) ? b[6] : b[1]; }

export function buyBundle(id) {
  const b = BUNDLES.find(x => x[0] === id);
  if (!b) return;
  openCheckout(`${b[2]} ${bundleName(b)} — ${b[3].toLocaleString()} 🪙`, parseFloat(b[5].slice(1)), () => grantBundle(b));
}

export function grantBundle(b) {
  WALLET.coins += b[3];
  saveWallet();
  banner(`+${b[3]} 🪙`);
  clack();
  if (b[3] >= 2600) fireworks();
  log(L(`Compraste ${bundleName(b)}: +${b[3].toLocaleString()} 🪙 (${b[5]}) ✅`, `You bought ${bundleName(b)}: +${b[3].toLocaleString()} 🪙 (${b[5]}) ✅`), true);
  try { renderDash(); } catch (e) {}
}

function isNativeApp(): boolean {
  const c = (window as any).Capacitor;
  return !!(c && c.isNativePlatform && c.isNativePlatform());
}
function tokenNow(): string { try { return localStorage.getItem('mdtoken') || ''; } catch (e) { return ''; } }

/** PRO purchase: the player picks a method, the server creates the checkout, and we send them there. */
export function buyPro(plan) {
  if (isNativeApp()) {
    log(L('Para hacerte PRO, entra a midomino.io desde tu navegador.', 'To go PRO, open midomino.io in your browser.'), true);
    return;
  }
  const prev = document.getElementById('pro-ov'); if (prev) prev.remove();
  const ov = document.createElement('div');
  ov.id = 'pro-ov';
  ov.style.cssText = 'position:fixed;inset:0;background:rgba(4,8,20,.82);z-index:9000;display:flex;align-items:center;justify-content:center;padding:16px';
  const price = plan === 'anual' ? '$86.40 / año' : '$9 / mes';
  ov.innerHTML = `<div style="background:var(--panel,#111a33);border:1px solid var(--gold);border-radius:16px;padding:22px;width:min(400px,92vw);text-align:center;color:#fff">
    <h3 style="margin:0 0 6px;color:#f0c24b">👑 DOMINO PRO CLUB</h3>
    <p style="opacity:.85;margin:0 0 14px">${price}</p>
    <button id="pro-card" class="btn" style="width:100%;margin:6px 0">💳 Tarjeta / Card (Stripe)</button>
    <button id="pro-local" class="btn" style="width:100%;margin:6px 0">🏦 Pago local / Local payment (dLocal)</button>
    <button id="pro-close" style="margin-top:10px;background:none;border:0;color:#aab;text-decoration:underline;cursor:pointer">Cancelar / Cancel</button></div>`;
  document.body.appendChild(ov);
  const close = () => ov.remove();
  (document.getElementById('pro-close') as HTMLElement).onclick = close;
  (document.getElementById('pro-card') as HTMLElement).onclick = () => { close(); startCheckout(plan, 'stripe'); };
  (document.getElementById('pro-local') as HTMLElement).onclick = () => { close(); startCheckout(plan, 'dlocal'); };
}

async function startCheckout(plan: string, provider: string) {
  const tk = tokenNow();
  if (!tk) { log(L('Inicia sesión para hacerte PRO.', 'Log in to go PRO.'), true); return; }
  const country = ((navigator.language || 'en-US').split('-')[1] || 'US').toUpperCase();
  try {
    const r = await fetch(API_BASE + '/api/pro/checkout', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + tk },
      body: JSON.stringify({ plan: plan === 'anual' ? 'annual' : 'monthly', provider, country }),
    });
    const j: any = await r.json().catch(() => null);
    if (!r.ok || !j || !j.url) { log(L('Pago no disponible: ', 'Payment not available: ') + ((j && j.error) || r.status), true); return; }
    location.href = j.url;
  } catch (e) { log(L('Error de conexión con el pago.', 'Connection error during payment.'), true); }
}

/** Ask the server whether this player is PRO. The browser never decides this itself. */
export async function syncPro(): Promise<void> {
  const tk = tokenNow();
  if (!tk) return;
  try {
    const r = await fetch(API_BASE + '/api/pro/status', { headers: { Authorization: 'Bearer ' + tk } });
    const j: any = await r.json().catch(() => null);
    if (!r.ok || !j) return;
    WALLET.pro = j.active ? { plan: j.pro.plan === 'annual' ? 'anual' : 'mensual', since: j.pro.since, lastDrop: 0 } : null;
    try { renderDash(); } catch (e) { /* dashboard not open */ }
  } catch (e) { /* offline: keep what we have */ }
}
setTimeout(() => { syncPro(); }, 1500);
if (location.search.indexOf('pro=ok') !== -1) {
  setTimeout(() => { log(L('¡Pago recibido! Bienvenido a PRO 👑', 'Payment received! Welcome to PRO 👑'), true); syncPro(); }, 2500);
}

function legacyBuyPro(plan) {
  openCheckout(plan === 'anual' ? L('👑 DOMINO PRO CLUB — Anual', '👑 DOMINO PRO CLUB — Yearly') : L('👑 DOMINO PRO CLUB — Mensual', '👑 DOMINO PRO CLUB — Monthly'), plan === 'anual' ? 99 : 11.99, () => grantPro(plan));
}

export function grantPro(plan) {
  WALLET.pro = { plan, since: Date.now(), lastDrop: 0 };
  if (plan === 'anual') {
    WALLET.vouchers.tables += 2;
    WALLET.vouchers.fichas += 1;
    WALLET.vouchers.t50 += 1;
    WALLET.vouchers.cheer = true;
    log(L('👑 ¡Bienvenido al DOMINO PRO CLUB ANUAL! $100 en valor: 2 mesas premium + 1 juego de fichas + 50% off torneo + cheerleaders. 🎉', '👑 Welcome to the YEARLY DOMINO PRO CLUB! $100 in value: 2 premium tables + 1 domino set + 50% off tournament + cheerleaders. 🎉'), true);
  } else {
    WALLET.vouchers.cheer = true;
    log(L('👑 ¡Bienvenido al DOMINO PRO CLUB! Tu primera 🔥 MESA CALIENTE está aquí.', '👑 Welcome to the DOMINO PRO CLUB! Your first 🔥 HOT TABLE is here.'), true);
  }
  saveWallet();
  celebration();
  fireworks();
  banner(L('👑 ¡PRO CLUB!', '👑 PRO CLUB!'));
  if (plan === 'mensual') claimMonthlyDrop(true);
  updateRankBadge();
  try { renderDash(); } catch (e) {}
}

export function claimMonthlyDrop(first) {
  if (!WALLET.pro) return;
  const now = Date.now();
  if (!first && now - (WALLET.pro.lastDrop || 0) < 27 * 864e5) {
    log(L('Tu próxima 🔥 MESA CALIENTE aún no está lista — vuelve el mes que viene.', 'Your next 🔥 HOT TABLE is not ready yet — come back next month.'), true);
    return;
  }
  WALLET.pro.lastDrop = now;
  WALLET.coins += 300;
  WALLET.vouchers.t25 = (WALLET.vouchers.t25 || 0) + 1;
  saveWallet();
  log(L('🔥 MESA CALIENTE: +300 🪙 + sobre premium (Rara+) + cupón 25% torneo.', '🔥 HOT TABLE: +300 🪙 + premium pack (Rare+) + 25% tournament coupon.'), true);
  setTimeout(() => {
    revealCollectible(pullCollectible(2), LANG === 'en' ? '🔥 Monthly HOT TABLE drop' : '🔥 MESA CALIENTE del mes');
  }, 800);
}

export function sellCollectible(id) {
  const copies = WALLET.collect.filter(x => x.id === id);
  if (!copies.length) return;
  const c = COLLECTIBLES.find(x => x.id === id);
  /* your lowest serial stays with you (the valuable one) — the newest copy sells */
  copies.sort((a, b) => b.serial - a.serial);
  const sold = copies[0];
  WALLET.collect = WALLET.collect.filter(x => !(x.id === id && x.serial === sold.serial));
  const price = SELL_VALUES[c.r];
  const fee = Math.round(price * MARKET_FEE);
  WALLET.coins += price - fee;
  saveWallet();
  clack();
  banner(`+${price - fee} 🪙`);
  const serialStr = String(sold.serial).padStart(4, '0');
  log(L(`🏪 Vendiste ${iname(c)} #${serialStr} por ${price} 🪙 · fee 10%: -${fee} → recibes ${price - fee} 🪙`,
        `🏪 You sold ${iname(c)} #${serialStr} for ${price} 🪙 · 10% fee: -${fee} → you get ${price - fee} 🪙`), true);
}

export function cardBrand(n) {
  if (n[0] === '4') return 'Visa';
  if (n[0] === '5') return 'Mastercard';
  if (n[0] === '3') return 'Amex';
  if (n[0] === '6') return 'Discover';
  return L('Tarjeta', 'Card');
}

export function payLabel(p, en) {
  if (!p) return '—';
  return p.type === 'card'
    ? `💳 ${p.brand} •••• ${p.last4} · ${en ? 'exp' : 'vence'} ${p.exp}`
    : `🪙 ${p.coin} · ${en ? 'wallet' : 'billetera'} ${p.wallet}`;
}

export function openCheckout(desc, usd, onPaid) {
  const old = document.getElementById('checkout-ov');
  if (old) old.remove();
  const en = LANG === 'en';
  const ov = document.createElement('div');
  ov.id = 'checkout-ov';
  ov.style.cssText = 'position:fixed;inset:0;background:rgba(4,8,20,.82);z-index:9000;display:flex;align-items:center;justify-content:center';
  ov.innerHTML = `<div class="tp-form" style="background:var(--panel,#111a33);border:1px solid var(--gold);border-radius:16px;padding:22px;width:min(430px,92vw);max-height:90vh;overflow:auto;text-align:left">
    <div style="display:flex;justify-content:space-between;align-items:center">
      <b style="font-size:17px">🧾 ${en ? 'Checkout' : 'Caja de pago'}</b>
      <button id="co-x" class="btn" style="margin:0;width:auto;padding:4px 10px">✕</button>
    </div>
    <div style="background:rgba(255,255,255,.05);border-radius:10px;padding:10px 12px;margin:12px 0;display:flex;justify-content:space-between;gap:10px">
      <span style="font-size:13px">${desc}</span><b style="color:var(--gold);white-space:nowrap">$${usd.toFixed(2)}</b>
    </div>
    <div style="background:rgba(240,180,41,.08);border:1px dashed var(--gold);border-radius:8px;padding:7px 10px;font-size:11px;opacity:.85;margin-bottom:12px">
      🧪 ${en ? 'DEMO MODE — no real charge. Stripe + on-chain rails activate at server launch.' : 'MODO DEMO — sin cargo real. Stripe + pagos on-chain se activan con el servidor.'}
    </div>
    <label style="font-size:12px;opacity:.8">${en ? 'Full name' : 'Nombre completo'} *</label>
    <input id="co-name" maxlength="40" value="${ACCOUNT.fullname || ''}" style="width:100%;margin:3px 0 8px">
    <label style="font-size:12px;opacity:.8">Email *</label>
    <input id="co-email" type="email" maxlength="60" value="${ACCOUNT.email || ''}" style="width:100%;margin:3px 0 12px">
    <div style="display:flex;gap:8px;margin-bottom:12px">
      <button class="btn" id="co-tab-card" style="flex:1;margin:0;background:var(--accent,#2456c9)">💳 ${en ? 'Card' : 'Tarjeta'}</button>
      <button class="btn" id="co-tab-crypto" style="flex:1;margin:0;background:#2a3558">🪙 Crypto</button>
    </div>
    <div id="co-card">
      <input id="co-num" placeholder="4242 4242 4242 4242" maxlength="19" inputmode="numeric" style="width:100%;margin-bottom:8px">
      <div style="display:flex;gap:8px">
        <input id="co-exp" placeholder="MM/AA" maxlength="5" style="flex:1;min-width:0">
        <input id="co-cvc" placeholder="CVC" maxlength="4" style="flex:1;min-width:0">
        <input id="co-zip" placeholder="ZIP" maxlength="10" style="flex:1;min-width:0">
      </div>
    </div>
    <div id="co-crypto" style="display:none">
      <select id="co-coin" style="width:100%;margin-bottom:8px"><option>USDC</option><option>BTC</option><option>ETH</option><option>SOL</option></select>
      <div style="background:rgba(255,255,255,.05);border-radius:8px;padding:10px;font-size:11px;word-break:break-all;text-align:center">
        ${en ? 'Send exactly' : 'Envía exacto'} <b style="color:var(--gold)">$${usd.toFixed(2)}</b> ${en ? 'to' : 'a'}:<br>
        <b>0xM1D0M1N0…demo…F1CHA2026</b>
      </div>
    </div>
    <button class="btn gold" id="co-pay" style="width:100%;margin-top:14px">${en ? 'PAY' : 'PAGAR'} $${usd.toFixed(2)}</button>
    <p id="co-err" style="color:#e05555;font-size:12px;min-height:14px;margin:6px 0 0"></p>
  </div>`;
  document.body.appendChild(ov);
  let method = 'card';
  const $c = id => ov.querySelector('#' + id);
  $c('co-x').onclick = () => ov.remove();
  $c('co-tab-card').onclick = () => { method = 'card'; $c('co-card').style.display = ''; $c('co-crypto').style.display = 'none'; $c('co-tab-card').style.background = 'var(--accent,#2456c9)'; $c('co-tab-crypto').style.background = '#2a3558'; };
  $c('co-tab-crypto').onclick = () => { method = 'crypto'; $c('co-card').style.display = 'none'; $c('co-crypto').style.display = ''; $c('co-tab-crypto').style.background = 'var(--accent,#2456c9)'; $c('co-tab-card').style.background = '#2a3558'; };
  $c('co-num').oninput = e => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 16).replace(/(\d{4})(?=\d)/g, '$1 '); };
  $c('co-exp').oninput = e => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 4).replace(/(\d{2})(?=\d)/, '$1/'); };
  $c('co-pay').onclick = () => {
    const name = $c('co-name').value.trim(), email = $c('co-email').value.trim();
    if (!name || !/.+@.+\..+/.test(email)) { $c('co-err').textContent = en ? 'Name and a valid email are required.' : 'Nombre y un email válido son requeridos.'; return; }
    if (method === 'card') {
      const num = $c('co-num').value.replace(/\s/g, '');
      if (num.length < 15 || $c('co-exp').value.length < 5 || $c('co-cvc').value.length < 3) { $c('co-err').textContent = en ? 'Check your card details.' : 'Revisa los datos de tu tarjeta.'; return; }
    }
    let payMeta;
    if (method === 'card') {
      const num = $c('co-num').value.replace(/\s/g, '');
      /* PCI standard: full number goes to the processor's vault — we keep only brand + last4 + exp */
      payMeta = { type: 'card', brand: cardBrand(num), last4: num.slice(-4), exp: $c('co-exp').value };
    } else {
      payMeta = { type: 'crypto', coin: $c('co-coin').value, wallet: '0x' + Math.random().toString(16).slice(2, 8) + '…' + Math.random().toString(16).slice(2, 6) };
    }
    ACCOUNT.fullname = name;
    ACCOUNT.email = email;
    ACCOUNT.pay = payMeta;
    saveAccount();
    $c('co-pay').textContent = en ? 'PROCESSING…' : 'PROCESANDO…';
    $c('co-pay').disabled = true;
    setTimeout(() => {
      recordSale(desc, usd, method === 'card' ? 'card' : 'crypto:' + payMeta.coin, payMeta);
      upsertSelfUser();
      ov.remove();
      banner('✔ ' + (en ? 'PAYMENT RECEIVED' : 'PAGO RECIBIDO'));
      clack();
      onPaid();
    }, 900);
  };
}

export function proUpsell(what) {
  showModal('👑 DOMINO PRO CLUB',
    `<p style="font-size:15px">${what}</p>
     <p style="opacity:.8;font-size:13px">${LANG === 'en'
       ? 'Rank up to King Kong, play on VIDEO, earn collectible drops, enter tournaments.'
       : 'Sube hasta King Kong, juega con VIDEO, gana coleccionables y entra a torneos.'}</p>
     <p style="font-size:19px"><b>$11.99/${L('mes', 'mo')}</b> · <b>$99/${L('año', 'yr')}</b> <small style="opacity:.7">${L('(≈$100 en valor incluido)', '(≈$100 in value included)')}</small></p>`,
    LANG === 'en' ? 'SEE PRO CLUB' : 'VER PRO CLUB',
    () => { setDashTab('pro'); openDash(); },
    true);
}

export function openTienda(tab) {
  if (tab) setTpTab(tab);
  document.getElementById('tienda-page').classList.add('show');
  renderTienda();
}

export function tpItemCard(it) {
  const owned = WALLET.owned.includes(it.id);
  const active = WALLET.active.includes(it.id);
  let sw;
  if (it.kind === 'flag' || it.kind === 'feltx') sw = `background:${it.bg}`;
  else if (it.kind === 'skin') sw = `background:${WOOD_SW[it.id] || 'var(--panel-light)'}`;
  else if (it.kind === 'fichas') sw = `background:${it.sw};color:${it.id === 'fich-ebano' ? '#f0b429' : '#333'}`;
  else sw = 'background:var(--panel-light)';
  const swContent = it.kind === 'bling' ? it.icon : (it.kind === 'fichas' ? '🁢 🁣 🁤' : '');
  return `<div class="tp-card">
    <div class="tp-swatch" style="${sw}">${swContent}</div>
    <b>${it.kind === 'flag' ? it.icon + ' ' : ''}${iname(it)}${active ? ' <span style="color:var(--gold)">●</span>' : ''}</b>
    <small>${idesc(it)}</small>
    <button class="btn${owned ? '' : ' gold'}" data-tp="${it.id}">${owned ? (active ? t('unequip') : t('equip')) : it.price + ' 🪙'}</button>
  </div>`;
}

export function tpToggle(id) {
  const it = STORE.find(s => s.id === id);
  if (!it) return;
  /* flags & designer felts share the felt → one exclusivity group */
  const groupOf = k => (k === 'flag' || k === 'feltx') ? 'felt' : k;
  const exclusive = ['skin', 'felt', 'fichas'];
  const clearGroup = g => {
    WALLET.active = WALLET.active.filter(x => groupOf((STORE.find(s => s.id === x) || {}).kind) !== g);
  };
  if (!WALLET.owned.includes(id)) {
    /* PRO vouchers pay first: yearly members carry 2 table + 1 ficha credits */
    const isTable = ['skin', 'feltx', 'flag'].includes(it.kind);
    if (isTable && WALLET.vouchers.tables > 0) {
      WALLET.vouchers.tables--;
      log(L(`🎟️ Canjeaste 1 voucher PRO de mesa por ${iname(it)} (te quedan ${WALLET.vouchers.tables})`, `🎟️ You redeemed 1 PRO table voucher for ${iname(it)} (${WALLET.vouchers.tables} left)`), true);
    } else if (it.kind === 'fichas' && WALLET.vouchers.fichas > 0) {
      WALLET.vouchers.fichas--;
      log(L(`🎟️ Canjeaste tu voucher PRO de fichas por ${iname(it)}`, `🎟️ You redeemed your PRO domino-set voucher for ${iname(it)}`), true);
    } else {
      if (WALLET.coins < it.price) { log(L(`No te alcanzan los 🪙 para ${iname(it)}. ¡Gana partidas o compra puntos!`, `Not enough 🪙 for ${iname(it)}. Win matches or buy points!`), true); return; }
      WALLET.coins -= it.price;
      log(L(`Compraste ${iname(it)} ✨`, `You bought ${iname(it)} ✨`), true);
    }
    WALLET.owned.push(id);
    if (exclusive.includes(groupOf(it.kind))) clearGroup(groupOf(it.kind));
    WALLET.active.push(id);
    clack();
  } else if (WALLET.active.includes(id)) {
    WALLET.active = WALLET.active.filter(x => x !== id);
  } else {
    if (exclusive.includes(groupOf(it.kind))) clearGroup(groupOf(it.kind));
    WALLET.active.push(id);
  }
  saveWallet();
  if (it.kind === 'fichas') syncSkinSelect();   // ⚙️ Fichas list mirrors owned/equipped sets
  if (it.kind === 'flag' || it.kind === 'feltx') syncFeltSelect();   // ⚙️ Table felt list
  if (it.kind === 'skin') syncWoodSelect();                           // ⚙️ Table wood list
  try {
    if (document.getElementById('tienda-page').classList.contains('show')) renderTienda();
    if (document.getElementById('dash-page').classList.contains('show')) renderDash();
  } catch (e) { renderTienda(); }
}

export function renderTienda() {
  document.getElementById('tp-bal').textContent = WALLET.coins;
  document.getElementById('tp-tabs').innerHTML = TP_TABS.map(([id, es, en]) =>
    `<button class="${tpTab === id ? 'active' : ''}" data-tab="${id}">${LANG === 'en' ? en : es}</button>`).join('');
  const body = document.getElementById('tp-body');
  const grid = kind => `<div class="tp-grid">${STORE.filter(i => i.kind === kind).map(tpItemCard).join('')}</div>`;
  if (tpTab === 'mesas') {
    body.innerHTML = `<p style="opacity:.75;margin-bottom:12px">${t('earnHint')}</p>` + grid('skin');
  } else if (tpTab === 'banderas') {
    body.innerHTML = `<p style="opacity:.75;margin-bottom:12px">${L('🌎 Lleva tu bandera al paño. Representa a tu país en cada partida.', '🌎 Bring your flag to the felt. Represent your country in every match.')}</p>` + grid('flag');
  } else if (tpTab === 'fichas') {
    body.innerHTML = `<p style="opacity:.75;margin-bottom:12px">${L('Juegos de fichas de colección.', 'Collectible domino sets.')}</p>` + grid('fichas');
  } else if (tpTab === 'extras') {
    body.innerHTML = `<p style="opacity:.75;margin-bottom:12px">${L('Bling para tu mesa — se pueden combinar.', 'Bling for your table — they can be combined.')}</p>` + grid('bling');
  } else if (tpTab === 'equipo') {
    body.innerHTML = `<div class="tp-card tp-form" style="max-width:540px;text-align:left">
      <b style="font-size:17px">👥 ${L('Crea tu equipo', 'Create your team')}</b>
      <p style="opacity:.7;font-size:13px;margin:4px 0 14px">${L('Tu equipo aparece en el marcador y en tu perfil.', 'Your team shows on the scoreboard and on your profile.')}</p>
      <label>${L('Nombre del equipo', 'Team name')}</label>
      <input id="tp-team-name" maxlength="16" placeholder="${L('Los Tigres del Malecón', 'The Malecón Tigers')}" value="${TEAM.name || ''}">
      <label>${L('Bandera del equipo', 'Team flag')}</label>
      <select id="tp-team-flag">${FLAG_LIST.map(f => `<option ${TEAM.flag === f[2] ? 'selected' : ''}>${f[2]}</option>`).join('')}</select>
      <label>${L('Grito de guerra', 'Battle cry')}</label>
      <input id="tp-team-motto" maxlength="40" placeholder="${L('¡Aquí se juega con corazón!', 'Here we play with heart!')}" value="${TEAM.motto || ''}">
      <button class="btn gold" id="tp-team-save" style="width:100%">${L('GUARDAR EQUIPO', 'SAVE TEAM')}</button>
    </div>

    <div class="tp-card tp-form" style="max-width:540px;text-align:left;margin-top:14px">
      <b style="font-size:16px">🎽 ${LANG === 'en' ? 'Team roster' : 'Plantilla del equipo'}</b>
      <p style="opacity:.7;font-size:12px;margin:4px 0 10px">${LANG === 'en' ? 'Captain + up to 5 compays. Your Pareja 🤝 is your table partner.' : 'Capitán + hasta 5 compays. Tu Pareja 🤝 es tu compañero de mesa.'}</p>
      <div style="display:flex;align-items:center;gap:8px;padding:7px 10px;background:var(--panel-light);border-radius:8px;margin-bottom:6px">
        ${PROFILE.photo ? `<img src="${PROFILE.photo}" style="width:30px;height:30px;border-radius:50%;object-fit:cover">` : `<span style="font-size:22px">${PROFILE.avatar}</span>`}
        <b style="flex:1;font-size:13px">${PROFILE.name || t('you')}</b>
        <small style="color:var(--gold);font-weight:800">👑 ${LANG === 'en' ? 'Captain' : 'Capitán'}</small>
      </div>
      ${TEAM.members.map((m, i) => `<div style="display:flex;align-items:center;gap:8px;padding:7px 10px;background:var(--panel-light);border-radius:8px;margin-bottom:6px">
        <span style="font-size:22px">${m.avatar}</span>
        <b style="flex:1;font-size:13px">${m.name}</b>
        <small style="opacity:.85">${m.role}</small>
        <button class="btn" data-rm="${i}" style="margin:0;width:auto;padding:3px 9px;font-size:11px">✕</button>
      </div>`).join('')}
      ${TEAM.members.length < 5 ? `<div style="display:flex;gap:6px;margin-top:8px">
        <input id="tp-mem-name" maxlength="14" placeholder="${LANG === 'en' ? 'Compay name' : 'Nombre del compay'}" style="flex:2;margin:0">
        <select id="tp-mem-avatar" style="flex:0 0 62px;margin:0">${['😎', '🧢', '💪🏽', '👵🏽', '🕶️', '🎩', '💃🏽', '🧔🏽'].map(a => `<option>${a}</option>`).join('')}</select>
        <select id="tp-mem-role" style="flex:1;margin:0">
          <option>🤝 Pareja</option><option>🔁 ${L('Suplente', 'Substitute')}</option><option>📣 Fan</option>
        </select>
        <button class="btn gold" id="tp-mem-add" style="margin:0;width:auto;padding:8px 12px">+</button>
      </div>` : ''}
      <div style="margin-top:14px;background:rgba(240,180,41,.1);border:1px dashed var(--gold);border-radius:10px;padding:10px;text-align:center">
        <small style="opacity:.8">${LANG === 'en' ? 'TEAM INVITE CODE — share it with your compays:' : 'CÓDIGO DE INVITACIÓN — compártelo con tus compays:'}</small><br>
        <b style="font-size:24px;letter-spacing:4px;color:var(--gold)">${teamCode()}</b><br>
        <small style="opacity:.6;font-size:10px">${LANG === 'en' ? 'When online mode ships, friends enter this code to join your team from their own game.' : 'Cuando llegue el modo online, tus amigos entran este código desde su juego y se unen a tu equipo.'}</small>
      </div>
      <div style="display:flex;gap:6px;margin-top:10px">
        <input id="tp-join-code" maxlength="9" placeholder="${LANG === 'en' ? 'Got a code? Join a team' : '¿Tienes un código? Únete'}" style="flex:1;margin:0;text-transform:uppercase">
        <button class="btn" id="tp-join-btn" style="margin:0;width:auto">${LANG === 'en' ? 'JOIN' : 'UNIRME'}</button>
      </div>
    </div>`;
    document.getElementById('tp-team-save').onclick = () => {
      TEAM.name = document.getElementById('tp-team-name').value.trim();
      TEAM.flag = document.getElementById('tp-team-flag').value;
      TEAM.motto = document.getElementById('tp-team-motto').value.trim();
      try { localStorage.setItem('team', JSON.stringify(TEAM)); } catch (e) {}
      applyProfile();
      log(L(`Equipo guardado: ${TEAM.flag} ${TEAM.name} — "${TEAM.motto}"`, `Team saved: ${TEAM.flag} ${TEAM.name} — "${TEAM.motto}"`), true);
      const b = document.getElementById('tp-team-save');
      b.textContent = LANG === 'en' ? '✔ SAVED!' : '✔ ¡GUARDADO!';
      b.style.background = '#1d9e75';
      setTimeout(() => renderTienda(), 1100);
    };
    const saveTeam = () => { try { localStorage.setItem('team', JSON.stringify(TEAM)); } catch (e) {} };
    const memAdd = document.getElementById('tp-mem-add');
    if (memAdd) {
      memAdd.onclick = () => {
        const nm = document.getElementById('tp-mem-name').value.trim();
        if (!nm) return;
        TEAM.members.push({
          name: nm,
          avatar: document.getElementById('tp-mem-avatar').value,
          role: document.getElementById('tp-mem-role').value,
        });
        saveTeam();
        log(`${nm} ${LANG === 'en' ? 'joined the team' : 'se unió al equipo'} 🎽`, true);
        clack();
        renderTienda();
      };
    }
    for (const rb of document.querySelectorAll('[data-rm]')) {
      rb.onclick = () => {
        const gone = TEAM.members.splice(+rb.dataset.rm, 1)[0];
        saveTeam();
        if (gone) log(`${gone.name} ${LANG === 'en' ? 'left the team' : 'salió del equipo'}`, true);
        renderTienda();
      };
    }
    const jb = document.getElementById('tp-join-btn');
    if (jb) {
      jb.onclick = () => {
        const code = document.getElementById('tp-join-code').value.trim().toUpperCase();
        if (!code) return;
        TEAM.joinRequest = code;
        saveTeam();
        log(LANG === 'en'
          ? `Join request saved for ${code} — it connects when online mode ships. 🔗`
          : `Solicitud guardada para ${code} — se conecta cuando llegue el modo online. 🔗`, true);
        renderTienda();
      };
    }
    return;
  } else if (tpTab === 'perfil') {
    const activeNames = WALLET.active.map(id => iname(STORE.find(s => s.id === id))).filter(Boolean);
    body.innerHTML = `
    <div style="display:grid;grid-template-columns:minmax(280px,380px) 1fr;gap:14px;align-items:start">
      <div class="tp-card tp-form" style="text-align:left">
        <div style="display:flex;align-items:center;gap:10px;margin-bottom:10px">
          ${PROFILE.photo
            ? `<img src="${PROFILE.photo}" style="width:56px;height:56px;border-radius:50%;object-fit:cover;border:2px solid var(--gold)">`
            : `<span style="font-size:44px">${PROFILE.avatar}</span>`}
          <div><b style="font-size:17px">${PROFILE.country} ${PROFILE.name || L('Jugador sin nombre', 'Unnamed player')}</b><br>
          <small style="opacity:.7">${TEAM.name ? TEAM.flag + ' ' + TEAM.name : L('Sin equipo', 'No team')}${TEAM.motto ? ' · "' + TEAM.motto + '"' : ''}</small></div>
        </div>
        <label>${L('Foto de perfil', 'Profile photo')}</label>
        <label class="btn" style="display:block;text-align:center;cursor:pointer;margin:5px 0 12px;width:100%">
          📸 ${LANG === 'en' ? 'Upload photo' : 'Subir foto'}
          <input type="file" id="tp-p-photo" accept="image/*" style="display:none">
        </label>
        <label>${L('Tu nombre', 'Your name')}</label>
        <input id="tp-p-name" maxlength="14" placeholder="Juan" value="${PROFILE.name || ''}">
        <label>Avatar</label>
        <select id="tp-p-avatar">${['🔥', '😎', '🎩', '👑', '🦁', '🐯', '💪🏽', '🎲', '🕶️', '🧔🏽'].map(a => `<option ${PROFILE.avatar === a ? 'selected' : ''}>${a}</option>`).join('')}</select>
        <label>${L('País', 'Country')}</label>
        <select id="tp-p-country">${FLAG_LIST.map(f => `<option ${PROFILE.country === f[2] ? 'selected' : ''}>${f[2]}</option>`).join('')}</select>
        <button class="btn gold" id="tp-p-save" style="width:100%">${L('GUARDAR PERFIL', 'SAVE PROFILE')}</button>
        <p style="margin-top:12px;font-size:12px;opacity:.75"><b>${L('Equipado:', 'Equipped:')}</b> ${activeNames.length ? activeNames.join(' · ') : L('Mesa clásica', 'Classic table')}</p>
      </div>
      <div>
        <div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(140px,1fr));gap:10px">
          <div class="tp-metric"><div class="v">${WALLET.coins}</div><div class="l">🪙 PhilCoins</div></div>
          <div class="tp-metric"><div class="v">${STATS.matchesWon}/${STATS.matches}</div><div class="l">🏆 ${L('Partidas ganadas', 'Matches won')}</div></div>
          <div class="tp-metric"><div class="v">${STATS.handsWon}/${STATS.hands}</div><div class="l">✋ ${L('Manos ganadas', 'Hands won')}</div></div>
          <div class="tp-metric"><div class="v">${STATS.capicus}</div><div class="l">🎯 Capicús</div></div>
          <div class="tp-metric"><div class="v">${STATS.chuchazos}</div><div class="l">💥 Chuchazos</div></div>
          <div class="tp-metric"><div class="v">${STATS.tranquesWon}</div><div class="l">🔒 ${L('Tranques ganados', 'Tranques won')}</div></div>
        </div>
      </div>
    </div>`;
    document.getElementById('tp-p-photo').onchange = ev => {
      const f = ev.target.files && ev.target.files[0];
      if (!f) return;
      const rd = new FileReader();
      rd.onload = () => {
        const img = new Image();
        img.onload = () => {
          const c = document.createElement('canvas');
          c.width = c.height = 220;
          const g = c.getContext('2d');
          const s = Math.min(img.width, img.height);
          g.drawImage(img, (img.width - s) / 2, (img.height - s) / 2, s, s, 0, 0, 220, 220);
          PROFILE.photo = c.toDataURL('image/jpeg', 0.82);
          try { localStorage.setItem('profile', JSON.stringify(PROFILE)); } catch (e) {}
          applyProfile();
          log(L('Foto de perfil guardada 📸', 'Profile photo saved 📸'), true);
          renderTienda();
        };
        img.src = rd.result;
      };
      rd.readAsDataURL(f);
    };
    document.getElementById('tp-p-save').onclick = () => {
      PROFILE.name = document.getElementById('tp-p-name').value.trim();
      PROFILE.avatar = document.getElementById('tp-p-avatar').value;
      PROFILE.country = document.getElementById('tp-p-country').value;
      try { localStorage.setItem('profile', JSON.stringify(PROFILE)); } catch (e) {}
      applyProfile();
      log(L(`Perfil guardado: ${PROFILE.country} ${PROFILE.name} ${PROFILE.avatar}`, `Profile saved: ${PROFILE.country} ${PROFILE.name} ${PROFILE.avatar}`), true);
      const b = document.getElementById('tp-p-save');
      b.textContent = LANG === 'en' ? '✔ SAVED!' : '✔ ¡GUARDADO!';
      b.style.background = '#1d9e75';
      setTimeout(() => renderTienda(), 1100);
    };
    for (const b of document.querySelectorAll('[data-tab]')) b.onclick = () => openTienda(b.dataset.tab);
    return;
  }
  for (const b of document.querySelectorAll('[data-tab]')) b.onclick = () => openTienda(b.dataset.tab);
  for (const b of document.querySelectorAll('[data-tp]')) b.onclick = () => tpToggle(b.dataset.tp);
}

/** Persist the wallet locally, repaint balance + bling, and (when signed in
 *  online) sync it to the cloud. */
export function saveWallet() {
  try { localStorage.setItem('wallet', JSON.stringify(WALLET)); } catch (e) {}
  updateCoinBal();
  applyBling();
  cloudSync();
}
